import React from "react"
import "../index.css"

function Header(){
    return(
        <header>
            <h1>Binary Boys</h1>
        </header>
    )
}
export default Header